<template>
  <div class="HomePage">
    <header-component></header-component>
    <div style="border-bottom: solid 1px whitesmoke; height: 1px"></div>
    <home-banner></home-banner>
    <home-icons></home-icons>
    <home-promo></home-promo>
    <home-block></home-block>
    <home-story></home-story>
    <home-invite
      v-if="elementConfig.inviteColleagueShow || MasterAccountType == 'master'"
    ></home-invite>
    <!-- <home-support></home-support> -->
    <help-info></help-info>
    <footer-component></footer-component>

    <!-- modal start 
    <covid-relief-modal-form @closeModal="CloseModal()"></covid-relief-modal-form>
    -->
    <div v-if="isCovidReliefModalFormShow">
      <covid-relief-modal-form
        @CtlModalForm="CtlModalForm()"
      ></covid-relief-modal-form>
    </div>
    <div v-if="isCovidReliefFeedbackResultModalShow">
      <covid-relief-feedback-result-modal
        :crps="crps"
        @CtlCovidReliefFeedbackResultModal="CtlCovidReliefFeedbackResultModal()"
      ></covid-relief-feedback-result-modal>
    </div>
    <!-- modal end -->.
  </div>
</template>
<script>
import HeaderComponent from "@/components/shared/HeaderComponent";
import FooterComponent from "@/components/shared/FooterComponent";
import HomeBanner from "@/components/portal/homeData/HomeBanner";
import HomeIcons from "@/components/portal/homeData/HomeIcons";
import HomePromo from "@/components/portal/homeData/HomePromo";
import HomeBlock from "@/components/portal/homeData/HomeBlock";
import HomeStory from "@/components/portal/homeData/HomeStory";
import HomeInvite from "@/components/portal/homeData/HomeInvite";
import HomeSupport from "@/components/portal/homeData/HomeSupport";
import CovidReliefModalForm from "@/components/shared/CovidReliefModalForm";
import CovidReliefFeedbackResultModal from "@/components/shared/CovidReliefFeedbackResultModal";
import HelpInfo from "@/components/portal/helpData/HelpInfo";

export default {
  components: {
    HeaderComponent,
    FooterComponent,
    HomeBanner,
    HomeIcons,
    HomePromo,
    HomeBlock,
    HomeStory,
    HomeInvite,
    CovidReliefModalForm,
    CovidReliefFeedbackResultModal,
    HomeSupport,
    HelpInfo,
  },

  props: ["HeaderComponent"],
  data() {
    return {
      isCovidReliefModalFormShow: false,
      isCovidReliefFeedbackResultModalShow: false,
      crps: null,
      MasterAccount: null,
    };
  },
  methods: {
    // covid relief campaign code start
    CtlModalForm() {
      this.crps = localStorage.getItem("covidReliefParticipantStatus");
      this.isCovidReliefModalFormShow = !this.isCovidReliefModalFormShow;
      if (this.crps == "Declined" || this.crps == "Enrolled") {
        this.isCovidReliefFeedbackResultModalShow =
          !this.isCovidReliefFeedbackResultModalShow;
      }
    },
    CtlCovidReliefFeedbackResultModal() {
      this.isCovidReliefFeedbackResultModalShow = false;
    },
    // covid relief campaign code end
  },
  created() {
    this.isActive = "home";
    localStorage.setItem("is-active", "home");
    this.MasterAccountType = localStorage.getItem("accountType");

    // covid relief campaign code start
    this.crps = localStorage.getItem("covidReliefParticipantStatus");
    var _cprs = this.crps;
    console.log("isCovidReliefStatusChecked", this.isCovidReliefStatusChecked);
    this.isCovidReliefStatusChecked =
      localStorage.getItem("isCovidReliefStatusChecked") || "false";
    if (this.isCovidReliefStatusChecked == "true") {
      this.isCovidReliefModalFormShow = false;
    } else {
      switch (_cprs) {
        case "":
          console.log("1");
        case undefined:
          console.log("2");
        case null:
          console.log("3");
        case "Not Seen":
          console.log("4");
        case "Reminder Requested":
          this.isCovidReliefModalFormShow = true;
          break;
        case "Enrolled":
        case "Declined":
          this.isCovidReliefModalFormShow = false;
          break;
        default:
          console.log("defaulting");
          this.isCovidReliefModalFormShow = true;
          break;
      }
    }
    console.log("crps", _cprs);
    console.log(
      "this.isCovidReliefModalFormShow",
      this.isCovidReliefModalFormShow
    );
    // covid relief campaign code end
  },
};
</script>



// WEBPACK FOOTER //
// Home.vue?635580af